import React from 'react';
import { Link } from '@tanstack/react-router';

import { cn } from '@/lib/utils';
import { buttonVariants } from '@/components/ui/button';

import { ILink } from '../AppSidebar/types';

interface SidebarNavProps extends React.HTMLAttributes<HTMLElement> {
  items: ILink[];
}

const SidebarNav: React.FC<SidebarNavProps> = ({
  className,
  items,
  ...props
}) => (
  <nav
    className={cn(
      'flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1',
      className,
    )}
    {...props}
  >
    {items.map((item) => (
      <Link key={item.to} to={item.to} activeOptions={{ exact: true }}>
        {({ isActive }) => (
          <span
            className={cn(
              buttonVariants({ variant: 'ghost' }),
              isActive
                ? 'bg-accent hover:bg-accent'
                : 'hover:bg-transparent hover:underline',
              'w-full justify-start',
            )}
          >
            {item.label}
          </span>
        )}
      </Link>
    ))}
  </nav>
);

export default SidebarNav;
